import { createContext, ReactNode, useEffect, useMemo, useState } from 'react';

interface IScreenSizeProviderProps {
  children?: ReactNode;
}

interface IScreenSizeContextData {
  windowWidth: number;
}

export const ScreenSizeContext = createContext<IScreenSizeContextData>({ windowWidth: 0 });

const ScreenSizeProvider = ({ children }: IScreenSizeProviderProps) => {
  const [windowWidth, setWindowWidth] = useState<number>(0);

  useEffect(() => {
    setWindowWidth(window.innerWidth);

    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  const contextValue = useMemo(() => ({ windowWidth }), [windowWidth]);

  return <ScreenSizeContext.Provider value={contextValue}>{children}</ScreenSizeContext.Provider>;
};

export default ScreenSizeProvider;
